"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

var _AssetSelectionHeader = _interopRequireDefault(require("./AssetSelectionHeader"));

var _AssetSelection = _interopRequireDefault(require("./AssetSelection"));

var _SourceAssetsInlineModal = _interopRequireDefault(require("./SourceAssetsInlineModal"));

var _AssetQuantityWarningModal = _interopRequireDefault(require("./AssetQuantityWarningModal"));

var _BulkActionModal = _interopRequireDefault(require("../../../../../common/components/BulkActionModal"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var VIDEO_ASSETS_THRESHOLD = 50;

function filterAssetsThatAreSelected(assets, selectedAssets) {
  return assets.filter(function (id) {
    return !selectedAssets.some(function (selectedId) {
      return selectedId === id;
    });
  });
}

var SelectFootage = /*#__PURE__*/function (_Component) {
  _inherits(SelectFootage, _Component);

  var _super = _createSuper(SelectFootage);

  function SelectFootage() {
    var _this;

    _classCallCheck(this, SelectFootage);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onBrowseForAssets", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(passedFiles) {
        var _this$props, addFileToQueue, organisationId;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, addFileToQueue = _this$props.addFileToQueue, organisationId = _this$props.organisationId;
                passedFiles.forEach( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                    var assetId;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return addFileToQueue({
                              file: file
                            }, organisationId);

                          case 2:
                            assetId = _context.sent;

                            _this.setState(function (prev) {
                              return {
                                assetBatch: [].concat(_toConsumableArray(prev.assetBatch), [assetId])
                              };
                            });

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "processAssetBatch", function () {
      var _this$props2 = _this.props,
          updateVideo = _this$props2.updateVideo,
          updateProject = _this$props2.updateProject;

      _this.setState(function (_ref3) {
        var assetBatch = _ref3.assetBatch;

        if (!assetBatch || !assetBatch.length) {
          return {};
        }

        var _this$props3 = _this.props,
            projectAssets = _this$props3.projectAssets,
            videoAssets = _this$props3.videoAssets;
        updateVideo({
          assetIds: [].concat(_toConsumableArray(videoAssets), _toConsumableArray(assetBatch))
        }, {
          override: true
        });
        updateProject({
          assetIds: [].concat(_toConsumableArray(projectAssets), _toConsumableArray(assetBatch))
        }, {
          override: true
        });
        return {
          assetBatch: []
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveAssets", function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          assetId = _ref4.assetId,
          removeFromProject = _ref4.removeFromProject;

      return function () {
        var selectedAssets = _this.state.selectedAssets;
        var _this$props4 = _this.props,
            updateVideo = _this$props4.updateVideo,
            updateProject = _this$props4.updateProject,
            projectAssets = _this$props4.projectAssets,
            videoAssets = _this$props4.videoAssets,
            assignedLabels = _this$props4.assignedLabels,
            onSave = _this$props4.onSave,
            clips = _this$props4.clips,
            editingMode = _this$props4.editingMode;
        var assetsToBeRemoved = assetId ? [assetId] : selectedAssets;
        var newVideoAssets = filterAssetsThatAreSelected(videoAssets, assetsToBeRemoved);
        var newSelected = assetId ? selectedAssets.filter(function (id) {
          return id !== assetId;
        }) : [];
        var newClips = clips.filter(function (clip) {
          return !assetsToBeRemoved.includes(clip.assetId);
        });
        var orderedNewClips = editingMode === 'BASIC' ? (0, _utils.setBasicClipsStartTimes)(newClips) : newClips;
        updateVideo({
          assetIds: newVideoAssets,
          clips: orderedNewClips
        }, {
          override: true
        });

        if (removeFromProject) {
          var newProjectAssets = filterAssetsThatAreSelected(projectAssets, assetsToBeRemoved);
          var newAssignedLabels = newProjectAssets.reduce(function (labels, newAssetId) {
            return _defineProperty({}, newAssetId, assignedLabels[newAssetId]);
          }, {});
          updateProject({
            assetIds: newProjectAssets,
            assignedLabels: newAssignedLabels
          }, {
            override: true
          });
        }

        _this.setState({
          selectedAssets: newSelected
        }, onSave);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleAssetApiResult", function (apiRes, assetId) {
      var data = apiRes.data,
          error = apiRes.error;

      if (!data || error) {
        return;
      }

      _this.onRemoveAssets({
        assetId: assetId,
        removeFromProject: true
      })();
    });

    _defineProperty(_assertThisInitialized(_this), "onArchiveAsset", function (assetId) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var archiveAsset;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  archiveAsset = _this.props.archiveAsset;
                  _context3.t0 = _this;
                  _context3.next = 4;
                  return archiveAsset(assetId);

                case 4:
                  _context3.t1 = _context3.sent;
                  _context3.t2 = assetId;

                  _context3.t0.handleAssetApiResult.call(_context3.t0, _context3.t1, _context3.t2);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteAsset", function (assetId) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var deleteAssets;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  deleteAssets = _this.props.deleteAssets;
                  _context4.t0 = _this;
                  _context4.next = 4;
                  return deleteAssets([assetId]);

                case 4:
                  _context4.t1 = _context4.sent;
                  _context4.t2 = assetId;

                  _context4.t0.handleAssetApiResult.call(_context4.t0, _context4.t1, _context4.t2);

                case 7:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "handleBulkActionRequest", (0, _lodash.default)(function (bulkActionRequest) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var selectedAssets, _yield$bulkActionRequ, data, error;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  selectedAssets = _this.state.selectedAssets;
                  _context5.next = 3;
                  return bulkActionRequest(selectedAssets);

                case 3:
                  _yield$bulkActionRequ = _context5.sent;
                  data = _yield$bulkActionRequ.data;
                  error = _yield$bulkActionRequ.error;

                  if (!(!data || error)) {
                    _context5.next = 8;
                    break;
                  }

                  return _context5.abrupt("return");

                case 8:
                  _this.onRemoveAssets({
                    removeFromProject: true
                  })();

                case 9:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "setLabelFilter", function (filter) {
      _this.setState({
        labelFilter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredAssets", function (assets) {
      var labelFilter = _this.state.labelFilter;
      var _this$props5 = _this.props,
          assignedLabels = _this$props5.assignedLabels,
          labels = _this$props5.labels;

      if (!labelFilter || labelFilter.value === 'ALL') {
        return assets;
      }

      var label = labels.find(function (_ref9) {
        var labelText = _ref9.label;
        return labelText === labelFilter.value;
      });

      if (!label) {
        return assets;
      }

      return Object.keys(assignedLabels).filter(function (assetId) {
        return assignedLabels[assetId].includes(label.id);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
      var videoAssets = _this.props.videoAssets;

      _this.setState(function (_ref10) {
        var selectedAssets = _ref10.selectedAssets;
        return {
          selectedAssets: selectedAssets.length === videoAssets.length ? [] : _toConsumableArray(videoAssets)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectAsset", function (assetId) {
      return function () {
        var selectedAssets = _this.state.selectedAssets;
        var isSelected = selectedAssets.includes(assetId);

        if (!isSelected) {
          return void _this.setState({
            selectedAssets: [].concat(_toConsumableArray(selectedAssets), [assetId])
          });
        }

        var newSelected = _toConsumableArray(selectedAssets);

        var index = newSelected.findIndex(function (id) {
          return assetId === id;
        });
        newSelected.splice(index, 1);

        _this.setState({
          selectedAssets: newSelected
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSourceFiles", function () {
      _this.setState(function (_ref11) {
        var sourcingAssets = _ref11.sourcingAssets;
        return {
          sourcingAssets: !sourcingAssets
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addSourcedAssetsToVideo", function () {
      var sourcedAssets = _this.state.sourcedAssets;
      var _this$props6 = _this.props,
          videoAssets = _this$props6.videoAssets,
          updateVideo = _this$props6.updateVideo;
      var uniqueAssets = sourcedAssets.filter(function (assetId) {
        return !videoAssets.some(function (videoAssetId) {
          return videoAssetId === assetId;
        });
      });
      updateVideo({
        assetIds: [].concat(_toConsumableArray(videoAssets), _toConsumableArray(uniqueAssets))
      }, {
        override: true
      });

      _this.setState({
        sourcedAssets: [],
        sourcingAssets: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveAndContinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _this$props7, goToNextStage, onSave, canUpdateVideo, _yield$onSave, error;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props7 = _this.props, goToNextStage = _this$props7.goToNextStage, onSave = _this$props7.onSave, canUpdateVideo = _this$props7.canUpdateVideo;

              if (canUpdateVideo) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return", void goToNextStage());

            case 3:
              _context6.next = 5;
              return onSave();

            case 5:
              _yield$onSave = _context6.sent;
              error = _yield$onSave.error;

              if (!error) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return");

            case 9:
              goToNextStage();

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleContinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var videoAssets;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              videoAssets = _this.props.videoAssets;

              if (!(videoAssets.length < VIDEO_ASSETS_THRESHOLD)) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return", _this.saveAndContinue());

            case 3:
              _this.setState({
                showWarningContinueModal: true
              });

              return _context7.abrupt("return", Promise.resolve());

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleWarningContinueModal", function () {
      _this.setState({
        showWarningContinueModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateSourcedAssets", function (assetIds) {
      _this.setState({
        sourcedAssets: assetIds
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBulkEditLabel", function () {
      _this.setState({
        showEditLabel: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBulkEditTags", function () {
      _this.setState({
        showEditTags: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBulkActionModalClose", function () {
      _this.setState({
        showEditLabel: false,
        showEditTags: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveAssetDetails", function () {
      var _this$props8 = _this.props,
          videoAssets = _this$props8.videoAssets,
          fetchAssetsForResource = _this$props8.fetchAssetsForResource,
          organisationId = _this$props8.organisationId,
          videoId = _this$props8.videoId;
      fetchAssetsForResource({
        data: {
          assetIds: videoAssets
        },
        resourceId: videoId,
        organisationId: organisationId
      });
    });

    _this.state = {
      selectedAssets: [],
      sourcedAssets: [],
      sourcingAssets: false,
      showEditLabel: false,
      showEditTags: false,
      assetBatch: []
    };
    return _this;
  }

  _createClass(SelectFootage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timer = setInterval(this.processAssetBatch, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          selectedAssets = _this$state.selectedAssets,
          labelFilter = _this$state.labelFilter,
          showWarningContinueModal = _this$state.showWarningContinueModal,
          sourcingAssets = _this$state.sourcingAssets,
          sourcedAssets = _this$state.sourcedAssets,
          showEditLabel = _this$state.showEditLabel,
          showEditTags = _this$state.showEditTags;
      var _this$props9 = this.props,
          videoAssets = _this$props9.videoAssets,
          projectAssets = _this$props9.projectAssets,
          updateProject = _this$props9.updateProject,
          labels = _this$props9.labels,
          assignedLabels = _this$props9.assignedLabels,
          onSave = _this$props9.onSave,
          canUpdateVideo = _this$props9.canUpdateVideo,
          project = _this$props9.project,
          addAssetsToMap = _this$props9.addAssetsToMap,
          archiveAssets = _this$props9.archiveAssets,
          deleteAssets = _this$props9.deleteAssets,
          hasDeleteAssetsPermission = _this$props9.hasDeleteAssetsPermission,
          hasArchiveAssetsPermission = _this$props9.hasArchiveAssetsPermission;
      var filteredAssetIds = this.getFilteredAssets(videoAssets);
      var buttonSaveText = canUpdateVideo ? 'SAVE & CONTINUE' : 'CONTINUE';
      var isBulkActionModalVisible = showEditLabel || showEditTags;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_commonReact.Autosave, {
          data: {
            videoAssets: videoAssets,
            projectAssets: projectAssets,
            assignedLabels: assignedLabels,
            labels: labels
          },
          functionToCall: onSave
        }) : null, /*#__PURE__*/_react.default.createElement(_AssetQuantityWarningModal.default, {
          visible: showWarningContinueModal,
          onContinue: this.saveAndContinue,
          onClose: this.toggleWarningContinueModal
        }), isBulkActionModalVisible && /*#__PURE__*/_react.default.createElement(_BulkActionModal.default, {
          visible: isBulkActionModalVisible,
          onClose: this.onBulkActionModalClose,
          selectedAssets: selectedAssets,
          labels: labels,
          showEditLabel: showEditLabel,
          showEditTags: showEditTags,
          assignedLabels: assignedLabels,
          updateProject: updateProject
        }), !sourcingAssets ? /*#__PURE__*/_react.default.createElement(_AssetSelectionHeader.default, {
          videoAssets: videoAssets,
          selectedAssets: selectedAssets,
          filteredAssets: filteredAssetIds,
          onBulkRemoveAssetsFromProject: this.onRemoveAssets({
            removeFromProject: true
          }),
          onBulkRemoveAssetsFromVideo: this.onRemoveAssets(),
          onBulkDeleteAssets: this.handleBulkActionRequest(deleteAssets),
          onBulkArchiveAssets: this.handleBulkActionRequest(archiveAssets),
          hasDeleteAssetsPermission: hasDeleteAssetsPermission,
          hasArchiveAssetsPermission: hasArchiveAssetsPermission,
          onBulkEditLabel: this.onBulkEditLabel,
          onBulkEditTags: this.onBulkEditTags,
          setLabelFilter: this.setLabelFilter,
          labels: labels,
          labelFilter: labelFilter,
          toggleSelectAllAssets: this.selectAll,
          canUpdateVideo: canUpdateVideo
        }) : null, sourcingAssets ? /*#__PURE__*/_react.default.createElement(_SourceAssetsInlineModal.default, {
          addAssetsToMap: addAssetsToMap,
          onClose: this.toggleSourceFiles,
          project: project,
          sourcedAssets: sourcedAssets,
          updateSourcedAssets: this.updateSourcedAssets
        }) : /*#__PURE__*/_react.default.createElement(_AssetSelection.default, {
          visibleAssetIds: filteredAssetIds,
          allAssetIds: videoAssets,
          onSelectFiles: this.onBrowseForAssets,
          onSelectAsset: this.onSelectAsset,
          selectedAssets: selectedAssets,
          updateProject: updateProject,
          labels: labels,
          assignedLabels: assignedLabels,
          onRemoveAssets: this.onRemoveAssets,
          onArchiveAsset: this.onArchiveAsset,
          onDeleteAsset: this.onDeleteAsset,
          toggleSourceFiles: this.toggleSourceFiles,
          onSaveAssetDetails: this.onSaveAssetDetails
        }), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: sourcingAssets ? "ADD SELECTED (".concat(sourcedAssets.length, ")") : buttonSaveText,
          onNext: sourcingAssets ? this.addSourcedAssetsToVideo : this.handleContinue,
          nextDisabled: sourcingAssets ? !sourcedAssets.length : !videoAssets.length
        }))
      );
    }
  }]);

  return SelectFootage;
}(_react.Component);

exports.default = SelectFootage;